import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";

interface TierSelectorProps {
  value: 'good' | 'better' | 'best';
  onChange: (tier: 'good' | 'better' | 'best') => void;
  className?: string;
}

export function TierSelector({ value, onChange, className }: TierSelectorProps) {
  return (
    <div className={className}>
      <div className="flex items-center gap-2 mb-2">
        <Sparkles className="h-4 w-4 text-primary" />
        <span className="text-sm font-medium">System Level:</span>
        {value === 'better' && (
          <Badge variant="secondary" className="text-xs">
            Recommended
          </Badge>
        )}
      </div>
      <ToggleGroup 
        type="single" 
        value={value} 
        onValueChange={(v) => v && onChange(v as 'good' | 'better' | 'best')}
        className="justify-start"
      >
        <ToggleGroupItem value="good" className="data-[state=on]:bg-muted">
          Good
        </ToggleGroupItem>
        <ToggleGroupItem value="better" className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground">
          Better
        </ToggleGroupItem>
        <ToggleGroupItem value="best" className="data-[state=on]:bg-amber-500 data-[state=on]:text-white">
          Best
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
}
